import {
    DataHandler,
    Logger
} from "@amzn/dolphin-web-framework";
import ThinClientCommunicator from "../../communication/ThinClientCommunicator";

/**
 * Sends a SourceScan event to Thin Client for SBL
 * @param {string} packageScannableId - The scanned package ID
 * @returns {boolean} True if sent successfully, false otherwise
 */
export const sblSourceScan = (packageScannableId) => {
    Logger.log.info("Fallback SBL SourceScan request: " + packageScannableId);
    try {
        // Prepare the data payload for the source scan
        const data = {
            eventName: 'SourceScan',
            processPath: 'Stow',
            payload: {
                nodeId: DataHandler.getStationCode(),
                userId: DataHandler.getUserEmployeeLogin(),
                scanContentType: 'PACKAGE',
                scanContent: packageScannableId,
                isDolphinFallbackEnabled: true,
                eventTime: Date.now()
            }
        };
        // Send the message to the thin client
        return ThinClientCommunicator.sendMessage(data);
    } catch (error) {
        Logger.log.error("Fallback SBL SourceScan error: " + JSON.stringify(error));
        return false;
    }
};

/**
 * Sends a DestinationScan event to Thin Client for SBL
 * @param {string} packageScannableId - Package being stowed
 * @param {string} destinationScannableId - Location ID where it’s being stowed
 * @returns {boolean} True if sent successfully, false otherwise
 */
export const sblDestinationScan = (packageScannableId, destinationScannableId) => {
    Logger.log.info("Fallback SBL DestinationScan request: " + destinationScannableId + " " + packageScannableId);
    try {
        // Prepare the data payload for the destination scan
        const data = {
            eventName: 'DestinationScan',
            processPath: 'Stow',
            payload: {
                nodeId: DataHandler.getStationCode(),
                userId: DataHandler.getUserEmployeeLogin(),
                scanContentType: 'LOCATION',
                scanContent: destinationScannableId,
                containerId: packageScannableId,
                crossStowEnabled: false,
                isManualScan: true,
                isDolphinFallbackEnabled: true,
                eventTime: Date.now()
            }
        };
        // Send the message to the thin client
        return ThinClientCommunicator.sendMessage(data);
    } catch (error) {
        Logger.log.error("Fallback SBL DestinationScan error: " + JSON.stringify(error));
        return false;
    }
};
